<template>
  <div class="box">
    <div class="head">
      <div class="ctb_icon"></div>
      <h2>穿梭巴士員工後臺管理系統</h2>
      <div class="right_fn">
        <div class="email none" @click="go_email">
          <img src="./images/email_icon.png" alt=""/>
        </div>

        <div class="user">
          <img src="./images/head_photo.png" alt="用戶頭像"/>
          <span>{{ name }}</span>

          <div class="headerMenus">
            <div class="item" v-if="false" @click="showChangePwd=true">
              修改密碼
            </div>
            <div class="item" @click="logout">
              退出登錄
            </div>
          </div>
        </div>
        <!-- 修改密碼彈框 -->
        <changePwd v-if="showChangePwd" @logout="logout" @closeChangePwdBox="closeChangePwdBox"/>
      </div>
    </div>
    <div class="content clearfix">
      <div class="tab">
        <ul>
          <li
            class="personnel_menu"
            :class="tabIndex === 0 ? 'active' : ''"
            @click="tab_click(0)"
          >
            <span></span>
            <span>員工資料</span>
          </li>
          <li
            class="buy_records_menu"
            :class="tabIndex === 1 ? 'active' : ''"
            @click="tab_click(1)"
          >
            <span></span>
            <span>購買記錄</span>
          </li>
          <li
            class="ride_records_menu"
            :class="tabIndex === 2 ? 'active' : ''"
            @click="tab_click(2)"
          >
            <span></span>
            <span>乘車記錄</span>
          </li>
        </ul>
      </div>
      <div class="panel">
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import changePwd from "../components/change_pwd/index.vue";

export default {
  data()
  {
    return {
      tabIndex: this.$route.meta.tabIndex,
      name: "",
      showChangePwd: false,
    };
  },
  created()
  {
    let that = this;
    if(this.getCookie("admin_name"))
    {
      this.name = this.getCookie("admin_name");
    }
    else
    {
      this.reLogin(function() {
        that.name = that.getCookie("admin_name");
      });
    }
  },
  computed: {
    routeIndex()
    {
      return this.$route.meta.tabIndex;
    },
  },
  watch: {
    routeIndex()
    {
      this.tabIndex = this.$route.meta.tabIndex;
    }
  },
  methods: {
    tab_click(tabIndex)
    {
      this.tabIndex = tabIndex;

      switch(tabIndex)
      {
        //員工資料
        case 0:
        {
          this.$router.push({name: 'personnel_manage'});
          break;
        }
        case 1:
        {
          this.$router.push({name: 'buy_records'});
          break;
        }
        case 2:
        {
          this.$router.push({name: 'ride_records'});
          break;
        }
      }
    },
    // 跳轉到郵件中心
    go_email()
    {
      // this.$router.push("/ekjt_manage/email_index");
    },
    // 關閉修改密碼彈框
    closeChangePwdBox()
    {
      return this.showChangePwd = false
    },
    //退出登錄
    logout()
    {
      this.$dialog.loading.open();
      this.axios.post(this.IP + this.PATH + "/logout", {}).then(response => {
        if(response.data.code === "SUCCESS")
        {
          this.$store.commit("token", "");
          this.$store.commit("saveAdmin_name", "");
          this.$store.commit("saveUsername", "");
          this.$store.commit("setUserInfo", "");
          window.localStorage.removeItem("token");
          this.delCookie("admin_name");
          this.delCookie("username");
          this.$notify({
            title: "成功",
            message: "退出登錄",
            type: "success"
          });
          this.$router.push({name: 'login'});
        }
        else
        {
          if(response.data.message)
          {
            this.$notify({
              title: "警告",
              message: response.data.message,
              type: "warning"
            });
          }
        }
        this.$dialog.loading.close();
      });
    }
  },
  components: {
    changePwd
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.box {
  /*max-width: 1920rem;*/
  min-width: 1366px;
  /*height: 100%;*/
  /*overflow: auto;*/
  color: #333;
  /*font-family: ".PingFang SC";*/
  background-color: #ffffff;
}

.head {
  width: 100%;
  height: 0.9rem;
  border-bottom: 1px solid #e8e8e8;
}

.head .right_fn {
  height: 100%;
  display: flex;
  align-items: center;
}

.head .email {
  width: 0.44rem;
  height: 0.44rem;
  cursor: pointer;
  position: relative;
  font-size: 0;
  text-align: center;
}

.head .email:hover {

  background-color: #e9f3fd;
  border-radius: 50%;
}

.head .email img {
  width: 0.28rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.head .ctb_icon {
  width: 1.46rem;
  height: 0.6rem;
  background: url("images/ctb_logo.png") no-repeat;
  background-size: 100% 100%;
  float: left;
  margin-left: 0.73rem;
  margin-top: 0.1rem;
}

.head h2 {
  font-size: 0.24rem;
  float: left;
  margin-left: 0.52rem;
  margin-top: 0.29rem;
}

.head .right_fn {
  float: right;
}

.head .user {
  position: relative;
  margin-left: 0.4rem;
  line-height: 0.44rem;
  cursor: pointer;
}

.head .user img {
  max-width: 0.44rem;
  max-height: 0.44rem;
  margin-right: 0.19rem;
  vertical-align: middle;
}

.head .user span {
  font-size: 0.2rem;
  margin-right: 0.83rem;
  display: inline-block;
  /* padding-top: 0.31rem; */
}

.head .user {
  height: 100%;
  display: flex;
  align-items: center;

  &:hover {
    .headerMenus {
      opacity: 1;
      display: flex;
    }
  }

  .headerMenus {
    z-index: 100;
    position: absolute;
    width: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, 30%);
    display: none;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    background-color: rgba(0, 0, 0, .8);
    color: white;
    border-radius: 3px;
    overflow: hidden;
    opacity: 0;
    transition: all .2s ease-in-out;

    .item {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      &:hover {
        background-color: rgba(255, 255, 255, .2);
      }
    }
  }
}


/* .content {
  width: 100%;
  overflow-x: hidden;
} */

.content .tab {
  float: left;
  width: 13%;
  //height: 8.57rem; border-right: 1px solid #e8e8e8; box-sizing: border-box;
}

.content .tab ul li {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  margin: 0.2rem 0;
  text-align: center;
  cursor: pointer;
  font-size: 0.16rem;
}

.content .tab ul li span:first-of-type {
  vertical-align: middle;
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  margin-right: .1rem;
}

.content .tab ul li.active {
  background-color: #f5f7fa;
}

.content .tab ul .personnel_menu span:first-of-type {
  background-image: url("images/personnel.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.content .tab ul .personnel_menu.active span:first-of-type {
  background-image: url("images/personnel_active.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.content .tab ul .buy_records_menu span:first-of-type {
  background-image: url("images/buy_records.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.content .tab ul .buy_records_menu.active span:first-of-type {
  background-image: url("images/buy_records_active.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.content .tab ul .ride_records_menu span:first-of-type {
  background-image: url("images/ride_records.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.content .tab ul .ride_records_menu.active span:first-of-type {
  background-image: url("images/ride_records_active.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.content .tab ul li span:first-of-type {
  background-size: auto 100%;
}

.content .tab ul li.active span:last-of-type {
  color: #1e7feb;
}

.content .panel {
  float: left;
  /*height: 857rem;*/
  width: 87%;
  background-color: #f5f7f8;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue